import cx from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';

interface IScrollableWrapperProps {
  className?: string;
}

export const ScrollableWrapper: React.FC<React.PropsWithChildren<IScrollableWrapperProps>> = ({
  children,
  className,
}) => {
  return (
    <div className={styles['outer']}>
      <div className={cx(styles['inner'], className)}>{children}</div>
    </div>
  );
};
